/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AppVersionConfig } from '../models';
// @ts-ignore
import type { CheckAppVersionResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { UpsertAppVersionConfigBody } from '../models';
/**
 * AppVersionApiApi - axios parameter creator
 */
export const AppVersionApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} appVersion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appVersionApiCheckAppVersion: async (appVersion: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appVersion' is not null or undefined
            assertParamExists('appVersionApiCheckAppVersion', 'appVersion', appVersion)
            const localVarPath = `/app-version/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (appVersion !== undefined) {
                localVarQueryParameter['app_version'] = appVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appVersionApiDeleteAppVersionConfig: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/app-version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appVersionApiGetAppVersionConfig: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/app-version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertAppVersionConfigBody} upsertAppVersionConfigBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appVersionApiUpsertAppVersionConfig: async (upsertAppVersionConfigBody: UpsertAppVersionConfigBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upsertAppVersionConfigBody' is not null or undefined
            assertParamExists('appVersionApiUpsertAppVersionConfig', 'upsertAppVersionConfigBody', upsertAppVersionConfigBody)
            const localVarPath = `/admin/app-version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertAppVersionConfigBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppVersionApiApi - functional programming interface
 */
export const AppVersionApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppVersionApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} appVersion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appVersionApiCheckAppVersion(appVersion: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckAppVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appVersionApiCheckAppVersion(appVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppVersionApiApi.appVersionApiCheckAppVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appVersionApiDeleteAppVersionConfig(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appVersionApiDeleteAppVersionConfig(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppVersionApiApi.appVersionApiDeleteAppVersionConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appVersionApiGetAppVersionConfig(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppVersionConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appVersionApiGetAppVersionConfig(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppVersionApiApi.appVersionApiGetAppVersionConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertAppVersionConfigBody} upsertAppVersionConfigBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appVersionApiUpsertAppVersionConfig(upsertAppVersionConfigBody: UpsertAppVersionConfigBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appVersionApiUpsertAppVersionConfig(upsertAppVersionConfigBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppVersionApiApi.appVersionApiUpsertAppVersionConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppVersionApiApi - factory interface
 */
export const AppVersionApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppVersionApiApiFp(configuration)
    return {
        /**
         * 
         * @param {AppVersionApiApiAppVersionApiCheckAppVersionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appVersionApiCheckAppVersion(requestParameters: AppVersionApiApiAppVersionApiCheckAppVersionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CheckAppVersionResponse> {
            return localVarFp.appVersionApiCheckAppVersion(requestParameters.appVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appVersionApiDeleteAppVersionConfig(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.appVersionApiDeleteAppVersionConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appVersionApiGetAppVersionConfig(options?: RawAxiosRequestConfig): AxiosPromise<AppVersionConfig> {
            return localVarFp.appVersionApiGetAppVersionConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AppVersionApiApiAppVersionApiUpsertAppVersionConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appVersionApiUpsertAppVersionConfig(requestParameters: AppVersionApiApiAppVersionApiUpsertAppVersionConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.appVersionApiUpsertAppVersionConfig(requestParameters.upsertAppVersionConfigBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for appVersionApiCheckAppVersion operation in AppVersionApiApi.
 */
export interface AppVersionApiApiAppVersionApiCheckAppVersionRequest {
    readonly appVersion: string
}

/**
 * Request parameters for appVersionApiUpsertAppVersionConfig operation in AppVersionApiApi.
 */
export interface AppVersionApiApiAppVersionApiUpsertAppVersionConfigRequest {
    readonly upsertAppVersionConfigBody: UpsertAppVersionConfigBody
}

/**
 * AppVersionApiApi - object-oriented interface
 */
export class AppVersionApiApi extends BaseAPI {
    /**
     * 
     * @param {AppVersionApiApiAppVersionApiCheckAppVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public appVersionApiCheckAppVersion(requestParameters: AppVersionApiApiAppVersionApiCheckAppVersionRequest, options?: RawAxiosRequestConfig) {
        return AppVersionApiApiFp(this.configuration).appVersionApiCheckAppVersion(requestParameters.appVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public appVersionApiDeleteAppVersionConfig(options?: RawAxiosRequestConfig) {
        return AppVersionApiApiFp(this.configuration).appVersionApiDeleteAppVersionConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public appVersionApiGetAppVersionConfig(options?: RawAxiosRequestConfig) {
        return AppVersionApiApiFp(this.configuration).appVersionApiGetAppVersionConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AppVersionApiApiAppVersionApiUpsertAppVersionConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public appVersionApiUpsertAppVersionConfig(requestParameters: AppVersionApiApiAppVersionApiUpsertAppVersionConfigRequest, options?: RawAxiosRequestConfig) {
        return AppVersionApiApiFp(this.configuration).appVersionApiUpsertAppVersionConfig(requestParameters.upsertAppVersionConfigBody, options).then((request) => request(this.axios, this.basePath));
    }
}

